<template>
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="calender-icon"
  >
    <path
      d="M3.77778 8.55H5.66667V10.45H3.77778V8.55ZM17 3.8V17.1C17 18.145 16.15 19 15.1111 19H1.88889C1.38792 19 0.907478 18.7998 0.553243 18.4435C0.199007 18.0872 0 17.6039 0 17.1L0.00944444 3.8C0.00944444 2.755 0.840556 1.9 1.88889 1.9H2.83333V0H4.72222V1.9H12.2778V0H14.1667V1.9H15.1111C16.15 1.9 17 2.755 17 3.8ZM1.88889 5.7H15.1111V3.8H1.88889V5.7ZM15.1111 17.1V7.6H1.88889V17.1H15.1111ZM11.3333 10.45H13.2222V8.55H11.3333V10.45ZM7.55556 10.45H9.44444V8.55H7.55556V10.45Z"
      fill="#e00b5b"
    />
  </svg>
</template>

<script>
export default {
  name: "CalendarIcon",
};
</script>

<style scoped></style>
